import { useCallback, useEffect, useState } from "react";
import { api } from "./api";
import { setActiveCategories, getActiveCategories } from "./categories";

// Fetches the user's custom category list and syncs the module-level cache
// used by categoryHex/categoryLabel across the app.
export function useCategories() {
  const [categories, setCategories] = useState(getActiveCategories());

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/categories");
      const list = r.data?.categories;
      if (Array.isArray(list) && list.length) {
        setActiveCategories(list);
        setCategories(list);
      }
    } catch { /* keep defaults */ }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return { categories, refresh };
}
